import React from "react";
import "../template-file-css/document-file-template.css";

export const AFHS_InsyncIntakeQuestions = ({ itemsRef, showErrorFor }) => {

    return (
        <div className='file-template'>
            <form id="AFHS_InsyncIntakeQuestions">

                <p className='w-750'><center><h3>INSYNC INTAKE QUESTIONS</h3></center>
                </p>

                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>First Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Last Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>DOB:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtFirstName' name='txtFirstName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLastName' name='txtLastName' className='add-only' /> </td>
                        <td className='w-250'> <input type='date' id='txtLastName' name='txtDob' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Email Address:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Mobile #:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Secondary #:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtEmailAddress' name='txtEmailAddress' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMobileNumber' name='txtMobileNumber' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtSecondaryNumber' name='txtSecondaryNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtAddress' name='txtAddress' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <span className='eleHeader'>Zip Code:</span> </td>
                        <td className='w-100'> <span className='eleHeader'>City:</span> </td>
                        <td className='w-100'> <span className='eleHeader'>State:</span> </td>
                        <td className='w-450'> <span className='eleHeader'>Allergy:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-100'> <input type='text' id='txtZipCode' name='txtZipCode' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtCity' name='txtCity' className='add-only' /> </td>
                        <td className='w-100'> <input type='text' id='txtState' name='txtState' className='add-only' /> </td>
                        <td className='w-450'> <input type='text' id='txtAllergy' name='txtAllergy' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Sex:</span>
                    <input type='radio' id='rbSex_Male' name='rbSex' className='add-only' value='Male' /> Male &nbsp;
                    <input type='radio' id='rbSex_Female' name='rbSex' className='add-only' value='Female' /> Female &nbsp;
                    <input type='radio' id='rbSex_Unknown' name='rbSex' className='add-only' value='Unknown' /> Unknown
                </p>

                <table>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Gender Identity:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbGenderIdentity_Male' name='rbGenderIdentity' className='add-only' value='Male' /> Male </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbGenderIdentity_Female' name='rbGenderIdentity' className='add-only' value='Female' /> Female </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbGenderIdentity_FemaleToMale' name='rbGenderIdentity' className='add-only' value='Female-to-Male' /> Female-to-Male(FTM)Transgender Male/Trans Man </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbGenderIdentity_MaleToFemale' name='rbGenderIdentity' className='add-only' value='Male-to-Female' /> Male-to-Female(MTF)Transgender Female/Trans Woman </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbGenderIdentity_Genderqueer' name='rbGenderIdentity' className='add-only' value='Genderqueer' /> Genderqueer, neither exclusive male or female </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbGenderIdentity_AdditionalGender' name='rbGenderIdentity' className='add-only' value='Additional gender category' /> Additional gender category, please specify <br />
                            <input type='text' id='txtAdditionalGenderCategory' name='txtAdditionalGenderCategory' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Sexual Orientation:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbSexualOrientation_Heterosexual' name='rbSexualOrientation' className='add-only' value='Heterosexual' /> Heterosexual </td>
                        <td className='w-375'>
                            <input type='radio' id='rbSexualOrientation_Homosexual' name='rbSexualOrientation' className='add-only' value='Homosexual' /> Homosexual </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbSexualOrientation_BiSexual' name='rbSexualOrientation' className='add-only' value='Bi-Sexual' /> Bi-Sexual </td>
                        <td className='w-375'>
                            <input type='radio' id='rbSexualOrientation_NonConforming' name='rbSexualOrientation' className='add-only' value='Other Non-Conforming' /> Other Non-Conforming </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbSexualOrientation_Other' name='rbSexualOrientation' className='add-only' value='Other' /> Other, please state <br />
                            <input type='text' id='txtrbSexualOrientation' name='txtrbSexualOrientation' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Marital Status:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_Married' name='rbMaritalStatus' className='add-only' value='Married' /> Married </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_Divorced' name='rbMaritalStatus' className='add-only' value='Divorced' /> Divorced </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_Single' name='rbMaritalStatus' className='add-only' value='Single' /> Single </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_ReMarried' name='rbMaritalStatus' className='add-only' value='Re-Married' /> Re-Married </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_Separated' name='rbMaritalStatus' className='add-only' value='Separated' /> Separated </td>
                        <td className='w-250'>
                            <input type='radio' id='rbMaritalStatus_Unknown' name='rbMaritalStatus' className='add-only' value='Unknown' /> Unknown </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbMaritalStatus_WidowWidower' name='rbMaritalStatus' className='add-only' value='Widow/Widower' /> Widow/Widower </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbMaritalStatus_Others' name='rbMaritalStatus' className='add-only' value='Others' /> Others <br />
                            <input type='text' id='txtOthers' name='txtOthers' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Client Race:</span> </p>
                <table>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbClientRace_Black' name='rbClientRace' className='add-only' value='Black' /> Black </td>
                        <td className='w-150'>
                            <input type='radio' id='rbClientRace_Caucasian' name='rbClientRace' className='add-only' value='Caucasian' /> Caucasian </td>
                        <td className='w-150'>
                            <input type='radio' id='rbClientRace_Asian' name='rbClientRace' className='add-only' value='Asian' /> Asian </td>
                        <td className='w-150'>
                            <input type='radio' id='rbClientRace_Hispanic' name='rbClientRace' className='add-only' value='Hispanic' /> Hispanic </td>
                        <td className='w-150'>
                            <input type='radio' id='rbClientRace_Unknown' name='rbClientRace' className='add-only' value='Unknown' /> Unknown </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbClientRace_Others' name='rbClientRace' className='add-only' value='Others' /> Others <br />
                            <input type='text' id='txtClientRaceOthers' name='txtClientRaceOthers' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Parent or Guardian / Next of Kin:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Parent/ Guardian/ Next of Kin Phone Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtGuardian' name='txtGuardian' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtParentPhoneNumber' name='txtParentPhoneNumber' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`In-Patient Hospital Stays: If so, Where and When:`}</span>
                    <input type='radio' id='rbPatientHospital_Yes' name='rbPatientHospital' className='add-only' value='Yes' /> Yes (Discharge Records Needed before Appt) &nbsp;
                    <input type='radio' id='rbPatientHospital_No' name='rbPatientHospital' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'>{`HX of Psych Meds:`}</span>
                    <input type='radio' id='rbPsychMeds_Yes' name='rbPsychMeds' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPsychMeds_No' name='rbPsychMeds' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbPsychMeds_Unknown' name='rbPsychMeds' className='add-only' value='Unknown' /> Unknown
                </p>

                <p className='w-750'><span className='eleHeader'>{`What Pharmacy is Convenient to Use:`}</span>
                    <input type='text' id='txtPharmacyIsConvenient' name='txtPharmacyIsConvenient' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>{`Is client pregnant?:`}</span>
                    <input type='radio' id='rbPregnant_Yes' name='rbPregnant' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPregnant_No' name='rbPregnant' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbPregnant_Na' name='rbPregnant' className='add-only' value='N/A' /> N/A &nbsp;
                    <input type='radio' id='rbPregnant_Unknown' name='rbPregnant' className='add-only' value='Unknown' /> Unknown
                </p>

                <p className='w-750'><span className='eleHeader'>{`Have you ever had Suicidal Thoughts: No/If yes, how often?`}</span>
                    <input type='radio' id='rbSuicidalThoughts_30Times' name='rbSuicidalThoughts' className='add-only' value='1-30 Times' /> 1-30 Times <br />
                    <input type='radio' id='rbSuicidalThoughts_60Times' name='rbSuicidalThoughts' className='add-only' value='30-60 Times' /> 30-60 Times <br />
                    <input type='radio' id='rbSuicidalThoughts_90Times' name='rbSuicidalThoughts' className='add-only' value='60-90 Times' /> 60-90 Times <br />
                    <input type='radio' id='rbSuicidalThoughts_90Times' name='rbSuicidalThoughts' className='add-only' value='90-Times or more' /> 90-Times or more
                </p>

                <p className='w-750'><span className='eleHeader'>{`Does client has an IEP? If yes, please provide records before BHA Ax`} </span>
                    <input type='radio' id='rbIep_No' name='rbIep' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbIep_Yes' name='rbIep' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIep_Na' name='rbIep' className='add-only' value='N/A' /> N/A &nbsp;
                    <input type='radio' id='rbIep_Unknown' name='rbIep' className='add-only' value='Unknown' /> Unknown
                </p>

                <table>
                    <tr>
                        <td className='w-200'> <span className='eleHeader'>Height:</span> </td>
                        <td className='w-175'> <span className='eleHeader'>Weight:</span> </td>
                        <td className='w-175'> <span className='eleHeader'>Hair Color:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Eye Color:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtHeight' name='txtHeight' className='add-only' /> </td>
                        <td className='w-175'> <input type='text' id='txtWeight' name='txtWeight' className='add-only' /> </td>
                        <td className='w-175'> <input type='text' id='txtHairColor' name='txtHairColor' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtEyeColor' name='txtEyeColor' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Problem Type: </span>
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBehavioralDisorders' name='cbBehavioralDisorders' className='add-only' value='BEHAVIORAL DISORDERS' /> BEHAVIORAL DISORDERS </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAdha' name='cbAdha' className='add-only' value='ADHA' /> ADHA </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAnxiety' name='cbAnxiety' className='add-only' value='ANXIETY' /> ANXIETY </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDepression' name='cbDepression' className='add-only' value='DEPRESSION' /> DEPRESSION </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBiPolar' name='cbBiPolar' className='add-only' value='BI-POLAR' /> BI-POLAR </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAnger' name='cbAnger' className='add-only' value='ANGER' /> ANGER </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFamilyConflict' name='cbFamilyConflict' className='add-only' value='FAMILY CONFLICT' /> FAMILY CONFLICT </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMoodIssues' name='cbMoodIssues' className='add-only' value='MOOD ISSUES' /> MOOD ISSUES </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMedication' name='cbMedication' className='add-only' value='MEDICATION' /> MEDICATION  </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPsychologicalEval' name='cbPsychologicalEval' className='add-only' value='PSYCHOLOGICAL EVAL' /> PSYCHOLOGICAL EVAL </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSchizophrenia' name='cbSchizophrenia' className='add-only' value='SCHIZOPHRENIA' /> SCHIZOPHRENIA </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSubstanceAvuse' name='cbSubstanceAvuse' className='add-only' value='SUBSTANCE ABUSE' /> SUBSTANCE ABUSE </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGriff' name='cbGriff' className='add-only' value='GRIEF' /> GRIEF </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPtsd' name='cbPtsd' className='add-only' value='PTSD' /> PTSD </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTrauma' name='cbTrauma' className='add-only' value='TRAUMA' /> TRAUMA  </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSexualAbuse' name='cbSexualAbuse' className='add-only' value='SEXUAL ABUSE' /> SEXUAL ABUSE </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProbation' name='cbProbation' className='add-only' value='PROBATION/PAROLE' /> PROBATION/PAROLE </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-200'> <span className='eleHeader'>PCP Name:</span> </td>
                        <td className='w-150'> <span className='eleHeader'>PCP#:</span> </td>
                        <td className='w-400'> <span className='eleHeader'>PCP Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtPcpName' name='txtPcpName' className='add-only' /> </td>
                        <td className='w-150'> <input type='text' id='txtPcp' name='txtPcp' className='add-only' /> </td>
                        <td className='w-400'> <input type='text' id='txtPcpAddress' name='txtPcpAddress' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`Has Client Ever Been Diagnosed with the following: (If yes, Please provide records showing last psychological test with full scale IQ)`}</span>
                    <input type='radio' id='rbDiagnosed_Autism' name='rbDiagnosed' className='add-only' value='Autism' /> Autism <br />
                    <input type='radio' id='rbDiagnosed_Idd' name='rbDiagnosed' className='add-only' value='IDD' /> IDD <br />
                    <input type='radio' id='rbDiagnosed_MentalRetardation' name='rbDiagnosed' className='add-only' value='Mental Retardation' /> Any Form of Mental Retardation/Developmental Disorder <br />
                    <input type='radio' id='rbDiagnosed_BrainInjury' name='rbDiagnosed' className='add-only' value='Brain Injury' /> Has client ever had a diagnosis of the following: Alzheimer's/Traumatic Brain Injury <br />
                    <input type='radio' id='rbDiagnosed_None' name='rbDiagnosed' className='add-only' value='None' /> None of the Above
                </p>

                <p className='w-750'><span className='eleHeader'>{`Has Client Ever Been Diagnosed with the following: (If yes, Please refer out immediately do not schedule)`}</span>
                    <input type='radio' id='rbBeenDiagnosed_Alzheimer' name='rbBeenDiagnosed' className='add-only' value='Alzheimer' /> Alzheimer's <br />
                    <input type='radio' id='rbBeenDiagnosed_Traumatic' name='rbBeenDiagnosed' className='add-only' value='Traumatic' /> Traumatic Brain Injury <br />
                    <input type='radio' id='rbBeenDiagnosed_None' name='rbBeenDiagnosed' className='add-only' value='None' /> None of the Above
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>{`Have You/Anyone in your Home Ever Tested Positive for Covid-19? : `}</span>

                    <input type='radio' id='rbCovid_Yes' name='rbCovid' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCovid_No' name='rbCovid' className='add-only' value='No' /> No &nbsp;

                </p>
                <p className='w-750'>

                    If yes, please provide date of diagnosis: 
                    <input type='date' id='txtCovid19' name='txtCovid19' className='add-only w-200 custom-add-only' />
                </p>


                <p className='w-750'><span className='eleHeader'>What Pharmacy Do you Currently Use:</span>
                    <input type='text' id='txtPharmacy' name='txtPharmacy' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-200'> <span className='eleHeader'>Current Occupation:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Employer Name:</span> </td>
                        <td className='w-350'> <span className='eleHeader'>Current School Name:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-200'> <input type='text' id='txtCurrentOccupation' name='txtCurrentOccupation' className='add-only' /> </td>
                        <td className='w-200'> <input type='text' id='txtEmployerName' name='txtEmployerName' className='add-only' /> </td>
                        <td className='w-350'> <input type='text' id='txtCurrentSchoolName' name='txtCurrentSchoolName' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`Do you have a Provider preference?:  If Yes, please state `}</span>
                    <input type='radio' id='rbProviderPreference_No' name='rbProviderPreference' className='add-only' value='No' /> No <br />
                    <input type='radio' id='rbProviderPreference_Yes' name='rbProviderPreference' className='add-only' value='Yes' /> Yes <br />
                    <input type='text' id='txtProviderPreference' name='txtProviderPreference' className='add-only' />
                </p>

                <p className='w-750'><span className='eleHeader'>{`Are you a Returning Client of AFHS?`}</span>
                    <input type='radio' id='rbAfhs_Yes' name='rbAfhs' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAfhs_No' name='rbAfhs' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><span className='eleHeader'>Sibling in Service with Apex:</span>
                    <input type='radio' id='rbApex_No' name='rbApex' className='add-only' value='No' /> No <br />
                    <input type='radio' id='rbApex_Yes' name='rbApex' className='add-only' value='Yes' /> Yes, Name/s: <br />
                    <input type='text' id='txtApex' name='txtApex' className='add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-300'> <span className='eleHeader'>Referral Resource and phone number:</span> </td>
                        <td className='w-200'> <span className='eleHeader'>Referral Date:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Staff Creating Profile:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-300'> <input type='text' id='txtReferralResource' name='txtReferralResource' className='add-only' /> </td>
                        <td className='w-200'> <input type='date' id='txtReferralDate' name='txtReferralDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtStaffCreatingProfile' name='txtStaffCreatingProfile' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`Do you have any Major Medical Issue/s: If yes, please state?`}</span>
                    <input type='radio' id='rbMedicalIssue_No' name='rbMedicalIssue' className='add-only' value='No' /> No <br />
                    <input type='radio' id='rbMedicalIssue_Unknown' name='rbMedicalIssue' className='add-only' value='Unknown' /> Unknown <br />
                    <input type='radio' id='rbMedicalIssue_Yes' name='rbMedicalIssue' className='add-only' value='Yes' /> Yes, Name/s: <br />
                    <input type='text' id='txtMedicalIssue' name='txtMedicalIssue' className='add-only' />
                </p>


            </form >
        </div>
    )

}